export default __webpack_public_path__ + "media/images/calling-b0272ac375a462b285782d5702bead3f.jpg";